import { Skeleton as DSSkeleton } from '@digibee/beehive-ui';
import React from 'react';
import styled from 'styled-components';

import Nav from '~/components/SideNav';

const Container = styled.div`
  width: 100%;
  background-color: ${props => props.theme.colors.white};
  font-family: ${props => props.theme.typography.fontFamily};
  padding-left: 8px;
  margin-top: 32px;
  z-index: 1;
  height: calc(100vh - 200px);
  overflow: auto;
  width: 208px;
`;

const Project = styled.div`
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 32px;
  margin: 8px 0px;
  cursor: pointer;
`;

const NavStyled = styled(Nav)`
  padding-top: 52px;
`;

type Props = {
  items?: number[];
};

const SideBarLoading: React.FC<Props> = ({ items: itemsProps }) => {
  const items = Array(itemsProps)
    .fill(undefined)
    .map((val, idx) => idx);

  return (
    <NavStyled>
      <Container>
        {items.map(item => (
          <Project key={item}>
            <DSSkeleton
              variant='rectangular'
              sizes='medium'
              style={{ width: '100%' }}
            />
          </Project>
        ))}
      </Container>
    </NavStyled>
  );
};

export default SideBarLoading;
